module.exports = __webpack_public_path__ + "static/media/praveen.ea2dd45d.jpg";